export type SchoolApprovalStatus = 'pending' | 'approved' | 'rejected';
export type SchoolDecision = 'approved' | 'rejected';

type DecisionInput = {
  decision: SchoolDecision;
  actorUid: string;
  timestamp: string;
  existingSchoolCode?: string | null;
  generatedSchoolCode?: string | null;
};

type DecisionUpdates = {
  school: Record<string, string | null>;
  owner: Record<string, string | null>;
};

export function normalizeSchoolApprovalStatus(status: unknown): SchoolApprovalStatus {
  return status === 'approved' || status === 'rejected' ? status : 'pending';
}

export function canDecideSchool(role: unknown, status: unknown): boolean {
  return role === 'superadmin' && normalizeSchoolApprovalStatus(status) === 'pending';
}

export function generateSchoolCode(): string {
  const alphabet = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
  const bytes = new Uint8Array(6);
  globalThis.crypto.getRandomValues(bytes);
  return Array.from(bytes, (value) => alphabet[value % alphabet.length]).join('');
}

export function buildSchoolDecisionUpdates(input: DecisionInput): DecisionUpdates {
  const approvalMetadata = input.decision === 'approved'
    ? {
        approvedAt: input.timestamp,
        approvedBy: input.actorUid,
        rejectedAt: null,
        rejectedBy: null,
      }
    : {
        approvedAt: null,
        approvedBy: null,
        rejectedAt: input.timestamp,
        rejectedBy: input.actorUid,
      };

  const owner = {
    approvalStatus: input.decision,
    ...approvalMetadata,
    updatedAt: input.timestamp,
  };
  const school: Record<string, string | null> = {
    ...owner,
  };

  if (input.decision === 'approved') {
    const schoolCode = input.existingSchoolCode || input.generatedSchoolCode;
    if (schoolCode) school.schoolCode = schoolCode;
  }

  return { school, owner };
}
